import { Link } from 'react-router-dom';
import { FeedbackMessage } from '../FeedbackMessage';
import type { AuthFeedback } from '../types';

export default function VerifyEmailTemplate({
    message,
    error,
    authHref,
}: {
    message: AuthFeedback | null;
    error: AuthFeedback | null;
    authHref: (mode: 'login') => string;
}) {
    return (
        <section className="mx-auto max-w-lg space-y-4">
            <div className="p-8 bg-coconut rounded-lg space-y-5">
                <h1 className="text-2xl font-semibold">Verify your email</h1>
                <p className="text-base text-licorice">We are checking your verification link.</p>

                <FeedbackMessage feedback={message} />
                <FeedbackMessage feedback={error} tone="error" />
            </div>

            <div className="mt-4 text-sm text-licorice">
                <span className="inline-block mr-0.5">Already have an account?</span>
                <Link
                    className="text-sm font-semibold underline decoration-dotted hover:no-underline"
                    to={authHref('login')}
                >
                    Log in
                </Link>
            </div>
        </section>
    );
}
